(function () {
  if (window.__bogoOfferProductsInitialized) return;
  window.__bogoOfferProductsInitialized = true;

  var modal = document.querySelector("[bogo-offer-product-popup]") || document.getElementById("offer-product-popup");
  if (!modal || !window.OfferProductsJson || !window.OfferProductsJson.bogo_products) return;
  window.openRebuyDrawerFromOfferPopup = window.openRebuyDrawerFromOfferPopup || function () {
    window.shouldPreventCartOpen = false;
    if (window.Rebuy && Rebuy.SmartCart) {
      setTimeout(function () {
        Rebuy.SmartCart.show();
      }, 80);
    }
  };

  var closeButton = modal.querySelector(".close");
  if (closeButton) {
    closeButton.onclick = function () {
      modal.style.display = "none";
      window.openRebuyDrawerFromOfferPopup();
    };
  }

  window.showBogoPopup = function (prodJson, variantId) {
    var freeProductHtml = "";
    var currentProd = prodJson;
    var bogoSettings = window.OfferProductsJson.bogo_products;
    var productName = currentProd.product_title || currentProd.title;

    freeProductHtml +=
      '<div class="product-data">' +
        '<form action="/cart.js" id="prod-form-' + currentProd.id + '" product-form>' +
          '<div class="media">' +
            '<img src="' + (currentProd.image || (currentProd.featured_image && currentProd.featured_image.url) || currentProd.images[0]) + '" height="200" width="200">' +
          "</div>" +
          '<div class="product-contents">' +
            '<div class="product-title">' + escapeHtml(productName) + "</div>" +
            '<input type="hidden" name="quantity" value="1">' +
            '<input type="hidden" name="properties[_free_product]" value="true">' +
            '<input type="hidden" name="id" value="' + variantId + '">' +
            '<div class="product-atc-wrapper">' +
              '<button type="submit" class="product-atc-btn btn button">Add to cart</button>' +
              '<button type="button" class="product-decline-btn btn button" product-decline-btn>' + escapeHtml(bogoSettings.continue_label) + "</button>" +
            "</div>" +
          "</div>" +
        "</form>" +
      "</div>";

    var popupProductsContainer = modal.querySelector("[offer-products]");
    if (!popupProductsContainer) return;

    var messageContainer = modal.querySelector(".free-product-message");
    if (messageContainer) messageContainer.textContent = bogoSettings.free_product_message;
    popupProductsContainer.innerHTML = freeProductHtml;
    window.applyEventsToBogoPopupAddBtns();
    modal.style.display = "flex";
  };

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  window.applyEventsToBogoPopupAddBtns = function () {
    modal.querySelectorAll("[product-decline-btn]").forEach(function (el) {
      el.addEventListener("click", function () {
        var continueUrl = window.OfferProductsJson.bogo_products.continue_url;
        if (continueUrl) {
          window.location.href = continueUrl;
          return;
        }
        modal.style.display = "none";
        window.openRebuyDrawerFromOfferPopup();
      });
    });

    modal.querySelectorAll("[product-form]").forEach(function (el) {
      el.addEventListener("submit", function (e) {
        e.preventDefault();
        var formData = new FormData(e.currentTarget);
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .then(function () {
            modal.style.display = "none";
            window.openRebuyDrawerFromOfferPopup();
          })
          .catch(function (error) {
            console.error("Error:", error);
          });
      });
    });
  };

  window.offerBogoProductPopup = function (variantId) {
    var checkDiv = setInterval(function () {
      if (document.querySelector("body.rebuy-cart-visible")) {
        clearInterval(checkDiv);
        if (typeof Rebuy !== "undefined") {
          Rebuy.SmartCart.hide();
        }
      }
    }, 100);

    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
        return response.json();
      })
      .then(function (cartData) {
        var addedIds = window.OfferProductsJson.bogo_products.added_product_ids.split(",");
        var productsCounter = 0;
        var bogoProduct = null;

        cartData.items.forEach(function (item) {
          if (addedIds.includes(String(item.variant_id)) && item.variant_id == variantId) {
            productsCounter += item.quantity;
            bogoProduct = item;
          }
        });

        if (productsCounter % 2 !== 0 && productsCounter > 0 && bogoProduct) {
          window.showBogoPopup(bogoProduct, variantId);
        } else {
          window.openRebuyDrawerFromOfferPopup();
        }
      })
      .catch(function (error) {
        console.error("Error fetching cart:", error);
      });
  };

  document.addEventListener("rebuy:cart.add", function (event) {
    if (!event || !event.detail) return;
    var variantId = (event.detail.variant && event.detail.variant.id) || (event.detail.item && event.detail.item.variant_id);
    if (variantId) {
      window.offerBogoProductPopup(variantId);
    }
  });
})();